export const anteriorlocations = [
  {
    locationId: 2,
    locationName: 'Head',
    buttonArr: [
      {
        burnType: 1,
        locationId: 2,
        locationName: 'Head',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 2,
        locationName: 'Head',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 2,
        locationName: 'Head',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 5,
    locationName: 'Chest/Lung',
    buttonArr: [
      {
        burnType: 1,
        locationId: 5,
        locationName: 'Chest/Lung',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 5,
        locationName: 'Chest/Lung',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 5,
        locationName: 'Chest/Lung',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 8,
    locationName: 'Pelvis/Gu',
    buttonArr: [
      {
        burnType: 1,
        locationId: 8,
        locationName: 'Pelvis/Gu',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 8,
        locationName: 'Pelvis/Gu',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 8,
        locationName: 'Pelvis/Gu',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 37,
    locationName: 'Left Arm',
    buttonArr: [
      {
        burnType: 1,
        locationId: 37,
        locationName: 'Left Arm',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 37,
        locationName: 'Left Arm',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 37,
        locationName: 'Left Arm',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 38,
    locationName: 'Right Arm',
    buttonArr: [
      {
        burnType: 1,
        locationId: 38,
        locationName: 'Right Arm',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 38,
        locationName: 'Right Arm',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 38,
        locationName: 'Right Arm',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 65,
    locationName: 'Left Leg',
    buttonArr: [
      {
        burnType: 1,
        locationId: 65,
        locationName: 'Left Leg',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 65,
        locationName: 'Left Leg',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 65,
        locationName: 'Left Leg',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
  {
    locationId: 66,
    locationName: 'Right Leg',
    buttonArr: [
      {
        burnType: 1,
        locationId: 66,
        locationName: 'Right Leg',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 66,
        locationName: 'Right Leg',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 66,
        locationName: 'Right Leg',
        label: '3rd Degree',
        unitLabel: '%',

        type: 'A',
      },
    ],
  },
  {
    locationId: 83,
    locationName: 'Genitalia',
    buttonArr: [
      {
        burnType: 1,
        locationId: 83,
        locationName: 'Genitalia',
        label: '1st Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 2,
        locationId: 83,
        locationName: 'Genitalia',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'A',
      },
      {
        burnType: 3,
        locationId: 83,
        locationName: 'Genitalia',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'A',
      },
    ],
  },
]

export const posteriorlocations = [
  {
    locationId: 2,
    locationName: 'Head',
    buttonArr: [
      {
        burnType: 1,
        locationId: 2,
        locationName: 'Head',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 2,
        locationName: 'Head',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 2,
        locationName: 'Head',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 8,
    locationName: 'Pelvis/Gu',
    buttonArr: [
      {
        burnType: 1,
        locationId: 8,
        label: '1st Degree',
        locationName: 'Pelvis/Gu',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 8,
        locationName: 'Pelvis/Gu',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 8,
        locationName: 'Pelvis/Gu',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 9,
    locationName: 'Back/Spine',
    buttonArr: [
      {
        burnType: 1,
        locationId: 9,
        locationName: 'Back/Spine',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 9,
        locationName: 'Back/Spine',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 9,
        locationName: 'Back/Spine',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 37,
    locationName: 'Left Arm',
    buttonArr: [
      {
        burnType: 1,
        locationId: 37,
        locationName: 'Left Arm',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 37,
        locationName: 'Left Arm',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 37,
        locationName: 'Left Arm',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 38,
    locationName: 'Right Arm',
    buttonArr: [
      {
        burnType: 1,
        locationId: 38,
        locationName: 'Right Arm',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 38,
        locationName: 'Right Arm',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 38,
        locationName: 'Right Arm',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 65,
    locationName: 'Left Leg',
    buttonArr: [
      {
        burnType: 1,
        locationId: 65,
        locationName: 'Left Leg',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 65,
        locationName: 'Left Leg',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 65,
        locationName: 'Left Leg',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
  {
    locationId: 66,
    locationName: 'Right Leg',
    buttonArr: [
      {
        burnType: 1,
        locationId: 66,
        locationName: 'Right Leg',
        label: '1st Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 2,
        locationId: 66,
        locationName: 'Right Leg',
        label: '2nd Degree',
        unitLabel: '%',
        type: 'P',
      },
      {
        burnType: 3,
        locationId: 66,
        locationName: 'Right Leg',
        label: '3rd Degree',
        unitLabel: '%',
        type: 'P',
      },
    ],
  },
]
